const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=DM+Sans:wght@400;500;600&display=swap');

  .ul-wrap {
    margin: 16px 0;
    padding: 16px 20px;
    background: rgba(0,0,0,0.04);
    border: 1px solid rgba(0,0,0,0.09);
    border-radius: 12px;
  }

  .ul-top {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    margin-bottom: 10px;
  }

  .ul-level {
    font-family: 'Bebas Neue', sans-serif;
    font-size: 2.2rem;
    line-height: 1;
    color: #c8880a;
    letter-spacing: 0.04em;
  }

  .ul-level span {
    font-size: 1rem;
    color: rgba(0,0,0,0.4);
    margin-left: 6px;
    font-family: 'DM Sans', sans-serif;
    font-weight: 500;
  }

  .ul-xp {
    font-family: 'DM Sans', sans-serif;
    font-size: 0.8rem;
    color: rgba(0,0,0,0.45);
  }

  .ul-xp strong {
    color: #c8880a;
    font-weight: 600;
  }

  .ul-bar-track {
    width: 100%;
    height: 8px;
    background: rgba(0,0,0,0.08);
    border-radius: 99px;
    overflow: hidden;
  }

  .ul-bar-fill {
    height: 100%;
    border-radius: 99px;
    background: linear-gradient(90deg, #c8880a, #f0c040);
    transition: width 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
  }

  .ul-bar-label {
    display: flex;
    justify-content: space-between;
    margin-top: 5px;
    font-family: 'DM Sans', sans-serif;
    font-size: 0.7rem;
    color: rgba(0,0,0,0.35);
  }
`;

const UserLevel = ({ level, totalXP, currentLevelXP, nextLevelXP }) => {
  const progressXP = totalXP - currentLevelXP;
  const requiredXP = nextLevelXP - currentLevelXP;
  const percent = Math.min(100, Math.round((progressXP / requiredXP) * 100));

  return (
    <>
      <style>{styles}</style>
      <div className="ul-wrap">
        <div className="ul-top">
          <div className="ul-level">
            Level {level}
          </div>
          <div className="ul-xp">
            Total XP: <strong>{totalXP.toLocaleString()}</strong>
          </div>
        </div>

        <div className="ul-bar-track">
          <div className="ul-bar-fill" style={{ width: `${percent}%` }} />
        </div>

        <div className="ul-bar-label">
          <span>{progressXP.toLocaleString()} XP</span>
          <span>{requiredXP.toLocaleString()} XP to next level</span>
        </div>
      </div>
    </>
  );
};

export default UserLevel;